import React, { useEffect, useState, Fragment } from "react";
import { observer, useObserver } from "mobx-react-lite";

/* packages */
import useForm from "../../util-hook-useform";
import useSuggest from "../../util-hook-usesuggest";
import validation from "../../util-inputs-validation";
import Input from "../../util-mui-inputs";
import { Buttons } from "../../util-atomic";
import { LocalStorage } from "../../lib-atomic-functions";
/* packages */

/* module */
import StepsLoader from "../loader/steps";
/* module */

/* functions */
import { OrderingCreate } from "../../app-module-ordering-container/functions";
/* functions */

import CONFIG from "../config";

const Index = observer(
  ({
    handleNext,
    handleBack,
    handleReset,
    handleCollection,
    collection,
    props,
  }) => {
    const { login } = LocalStorage.getLS();
    const { token } = login;
    const [confirm, setConfirm] = useState(false);

    const formObjects = CONFIG.application.notes.objects;

    /* states */
    const { orderCreateContext, orderCreateMethod, orderCreateData } =
      OrderingCreate({ CONFIG, token });
    const orderLoading = orderCreateContext.loading;
    /* states */

    const finishNext = () => {
      handleNext();
    };

    const finishBack = () => {
      handleBack();
    };

    const finishValidate = async () => {
      handleCollection("notes", values.notes);
      handleCollection("po", values.purchaseOrder);
      const bodyData = {
        clientId: collection.company.id,
        clientContactId: collection.contact.id,
        purchaseOrder: collection.po,
        notes: collection.notes,
        products: [...collection.products, ...collection.fees],
      };
      console.log(bodyData, " bodyData");
      // await orderCreateMethod(JSON.stringify(bodyData));
      if (orderCreateContext.data.outcomeCode === "0") {
        const orderId = orderCreateContext.data.orderId;
        // props.history.push("/orders/l/success-quote-create/" + orderId);
      }
    };

    const handleConfirm = () => {
      setConfirm(!confirm);
    };

    const { values, errors, handleChange, handleSubmit, handleValue } = useForm(
      finishValidate,
      validation,
      formObjects,
      false
    );

    /* form: step 3 */
    const poFormObject = {
      ...formObjects.purchaseOrder,
      errors: errors.purchaseOrder,
      value: values.purchaseOrder,
      handleChange: handleChange,
    };
    const noteFormObject = {
      ...formObjects.notes,
      errors: errors.notes,
      value: values.notes,
      handleChange: handleChange,
    };
    /* form: step 3 */

    if (orderLoading) return <StepsLoader />;

    return (
      <form onSubmit={handleSubmit} noValidate>
        <p>Purchase details, notes/coments</p>
        <Input.Text {...poFormObject} />
        <Input.Textarea {...noteFormObject} />
        <br />

        {!confirm && (
          <section className="space-standard-top space-standard-bottom">
            <Buttons.Primary onClick={handleConfirm}>
              Confirm and submit
            </Buttons.Primary>
          </section>
        )}

        {confirm && (
          <section className="space-standard-top space-standard-bottom">
            <p>
              <b>You are about to create this quote, do you wish to continue</b>
            </p>
            <Buttons.Normal>Continue and Submit</Buttons.Normal>
            <Buttons.Primary onClick={handleConfirm}>Cancel</Buttons.Primary>
          </section>
        )}

        <br />
        <hr />
        <Buttons.DefaultSmallNon onClick={finishBack}>
          Back
        </Buttons.DefaultSmallNon>
      </form>
    );
  }
);

export default Index;
